// This functional component is solely used to allow the react-select elemment contained within to access the light / dark theme toggle of the app at large
import { useMantineColorScheme } from '@mantine/core';
import HardwareTicketDetails from './Hardware-Ticket-Details';

export default function HardwareTicketDetailsWrapper(props) {
  const { colorScheme } = useMantineColorScheme();

  return <HardwareTicketDetails {...props} colorScheme={colorScheme} />;
}